export default "/assets/embed_el-3dd92bf0d7d942fbabd741e44d3ba94630fccabf776cda482475863be1625369.svg";